<template>
  <div class="stripe-form">
    <div class="form-container">
      <div class="form-section">

        <!-- Apple Pay -->
        <!-- Временно отключено
        <div class="form-group" v-if="paymentRequestAvailable">
          <div id="payment-request-button"></div>
        </div>
        -->

        <!-- Manual card form -->
        <div class="form-group">
          <label>{{ $t('StripePayment.cardNumber') }}</label>
          <div id="card-number-element" class="custom-stripe-input"></div>
          <div v-if="cardError" class="error-message">{{ cardError }}</div>
        </div>

        <div class="form-row">
          <div class="form-group half">
            <label>{{ $t('StripePayment.valPeriod') }}</label>
            <div id="card-expiry-element" class="custom-stripe-input"></div>
          </div>
          <div class="form-group half">
            <label>CVC</label>
            <div id="card-cvc-element" class="custom-stripe-input"></div>
          </div>
        </div>

        <custom-button
            :text="$t('StripePayment.pay')"
            :loading="loading"
            :disabled="loading"
            @click="handleSubmit"
        />
      </div>

      <simple-dialog
          v-model="showDialog"
          :success="true"
          :title="$t('StripePayment.paid')"
          @change="handleDialogClose"
      />
    </div>
  </div>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js";
import CustomButton from "@/components/forms/CustomButton";
import SimpleDialog from "@/components/content/SimpleDialog";

const STRIPE_PUBLISHABLE_KEY =
  process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY ||
  "pk_live_51T6suzKAb7dXwnQeVFoVWy5I5Ei0kLLOTQov0c15rrJcb9ggs4tw0CteSDyHh4oBhHK5cBHDSaPoXLdhOdBXlsgm00DLahNh9x";

export default {
  name: "StripePayment",
  components: { CustomButton, SimpleDialog },
  data() {
    return {
      stripe: null,
      elements: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      cardError: "",
      loading: false,
      showDialog: false,
      // Временно отключено
      // paymentRequest: null,
      // paymentRequestAvailable: false,
    };
  },
  methods: {
    async handleSubmit() {
      // Проверка полей карты
      
      if (!this.cardNumber) {
        this.cardError = "Введіть номер карти";
        return;
      }
      
      // Проверка состояния полей карты
      const cardNumberComplete = this.cardNumber._complete;
      const cardExpiryComplete = this.cardExpiry._complete;
      const cardCvcComplete = this.cardCvc._complete;
      
      if (!cardNumberComplete) {
        this.cardError = "Некорректный номер карты";
        return;
      }
      
      if (!cardExpiryComplete) {
        this.cardError = "Некорректный срок действия";
        return;
      }
      
      if (!cardCvcComplete) {
        this.cardError = "Некорректный CVC код";
        return;
      }

      this.loading = true;
      this.cardError = "";

      try {
        const { error, paymentMethod } = await this.stripe.createPaymentMethod({
          type: "card",
          card: this.cardNumber,
          // Email будет предоставлен на бэкенде
          billing_details: {},
        });

        if (error) {
          this.cardError = error.message;
          return;
        }

        const response = await this.$store.dispatch("Payment/createSubscriptionDirect", {
          stripeData: {
            // Email будет предоставлен на бэкенде
            user_id: this.$store.state.Auth.user_id,
            app_id: this.$store.state.Auth.nativeData.id,
            payment_method_id: paymentMethod.id,
          },
        });

        if (response.success) {
          this.$store.commit("Auth/SET_USER_STATUS", 1);
          this.$store.commit("Auth/SET_USER_STATUS_SUB", 1);
          this.showDialog = true;
        } else {
          this.cardError = response.error || "Сталася помилка під час cплати.";
        }
      } catch (err) {
        this.cardError = "Помилка під час створення оплати";
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async handleDialogClose() {
      // Перенаправляем на страницу добавления карты
      await this.$router.push({
        name: "AddCard",
        params: this.$route.params,
      });
    },
  },
  async mounted() {
    this.stripe = await loadStripe(STRIPE_PUBLISHABLE_KEY);
    this.elements = this.stripe.elements();

    // Apple Pay setup - временно отключено
    /*
    this.paymentRequest = this.stripe.paymentRequest({
      country: "US",
      currency: "usd",
      total: {
        label: "Subscription",
        amount: 142,
      },
      requestPayerName: false,
      requestPayerEmail: false, // Email будет предоставлен на бэкенде
    });

    const result = await this.paymentRequest.canMakePayment();
    if (result && result.applePay) {
      this.paymentRequestAvailable = true;

      const prButton = this.elements.create("paymentRequestButton", {
        paymentRequest: this.paymentRequest,
        style: {
          paymentRequestButton: {
            type: "buy",
            theme: "black",
            height: "44px",
          },
        },
      });

      prButton.mount("#payment-request-button");

      this.paymentRequest.on("paymentmethod", async (ev) => {
        try {
          const response = await this.$store.dispatch("Payment/createSubscriptionDirect", {
            stripeData: {
              // Email будет предоставлен на бэкенде
              user_id: this.$store.state.Auth.user_id,
              app_id: this.$store.state.Auth.nativeData.id,
              payment_method_id: ev.paymentMethod.id,
            },
          });

          if (response.success) {
            ev.complete("success");
            this.$store.commit("Auth/SET_USER_STATUS", 1);
            this.$store.commit("Auth/SET_USER_STATUS_SUB", 1);
            this.showDialog = true;
          } else {
            ev.complete("fail");
            this.cardError = response.error || "Помилка під час оплати через Apple Pay.";
          }
        } catch (err) {
          ev.complete("fail");
          this.cardError = "Apple Pay помилка";
          console.error(err);
        }
      });
    }
    */

    // Стиль для обычной карты
    const style = {
      base: {
        fontSize: "16px",
        color: "#2d3748",
        fontFamily: "system-ui, sans-serif",
        "::placeholder": { color: "#a0aec0" },
      },
      invalid: {
        color: "#e23744",
        iconColor: "#e23744",
      },
    };

    // Карточные поля
    this.cardNumber = this.elements.create("cardNumber", { style });
    this.cardNumber.mount("#card-number-element");

    this.cardExpiry = this.elements.create("cardExpiry", { style });
    this.cardExpiry.mount("#card-expiry-element");

    this.cardCvc = this.elements.create("cardCvc", { style });
    this.cardCvc.mount("#card-cvc-element");

    // Обработчики изменений полей карты
    this.cardNumber.on("change", (event) => {
      if (event.error) {
        this.cardError = event.error.message;
      } else {
        // Сбрасываем ошибку только если она была связана с номером карты
        if (this.cardError.includes("номер карты")) {
          this.cardError = "";
        }
      }
    });
    
    this.cardExpiry.on("change", (event) => {
      if (event.error) {
        this.cardError = event.error.message;
      } else {
        // Сбрасываем ошибку только если она была связана со сроком действия
        if (this.cardError.includes("срок действия")) {
          this.cardError = "";
        }
      }
    });
    
    this.cardCvc.on("change", (event) => {
      if (event.error) {
        this.cardError = event.error.message;
      } else {
        // Сбрасываем ошибку только если она была связана с CVC
        if (this.cardError.includes("CVC")) {
          this.cardError = "";
        }
      }
    });
  },
};
</script>

<style scoped>
.stripe-form {
  background: #f8fafc;
  padding: 1rem;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.form-container {
  background: #fff;
  border-radius: 12px;
  padding: 2rem;
  width: 100%;
  max-width: 480px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.form-section {
  margin-top: 1rem;
}

.form-group {
  margin-bottom: 1.25rem;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.form-row {
  display: flex;
  gap: 1rem;
}

.half {
  flex: 1;
}

.custom-stripe-input {
  padding: 0.75rem;
  border: 1px solid #cbd5e0;
  transition: border-color 0.2s ease-in-out;
  border-radius: 8px;
  background-color: white;
  font-size: 1rem;
  transition: border-color 0.2s ease;
}

.custom-stripe-input.StripeElement--focus {
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
}

.custom-stripe-input.StripeElement--invalid {
  border-color: #e3626e;
}

.error-message {
  color: #e3626e;
  font-size: 0.875rem;
  margin-top: 0.25rem;
  font-weight: 500;
}
</style>
